import Attendee from './attendeeModel';

export const ORIGIN_ADD_MANUAL = 6;
export const ORIGIN_STOCK_PRINT = 8;

export default class Order {
    constructor({ attendees, buyer_email, buyer_first_name, buyer_last_name, id_transaction, sold_date, transaction_reference }) {
        this.attendees = attendees.map(attendee => new Attendee(attendee));
        this.buyerEmail = buyer_email;
        this.buyerFirstName = buyer_first_name;
        this.buyerLastName = buyer_last_name;
        this.id = id_transaction;
        this.idTransaction = this.id;
        this.soldDate = new Date(sold_date);
        this.transactionReference = transaction_reference;
        this.reference = this.transactionReference;
    }

    includesAllAttendees(selected) {
        return !this.attendees.some(attendee => selected.findIndex(sattendee => sattendee.pk === attendee.pk) === -1);
    }
}
